import workspaceQuery from 'graphql/queries/vat/VatProductCategoryWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/vat/VatProductCategoryListQuery.graphql';
import instanceQuery from 'graphql/queries/vat/VatProductCategoryQuery.graphql';
import defaultQuery from 'graphql/queries/vat/VatProductCategoryDefault.graphql';
import mutationQuery from 'graphql/mutations/vat/VatProductCategoryMutation.graphql';
import fragment from 'graphql/fragments/vat/VatProductCategoryFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const VatProductCategory: EntityType = {
  type: 'VatProductCategory',
  title: 'Product VAT Category',
  formTitle: 'Product VAT Category',
  formUrl: '/Vat/ProductCategory/Details/',
  workspaceUrl: '/Vat/ProductCategory/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'VAT_PRODUCT_CATEGORIES',
};

export default VatProductCategory;
